export enum RefundVariantEnum {
	DEFAULT = 'default',
	PREVIEW = 'preview',
	ADDITIONAL_DOCUMENTS = 'sendAdditionalDocuments',
}
